import { render } from "./PickerDay.vue?vue&type=template&id=23c95c37"
import script from "./PickerDay.vue?vue&type=script&lang=js"
export * from "./PickerDay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__